import { render, staticRenderFns } from "./myResourcesList.vue?vue&type=template&id=45286bec&scoped=true"
import script from "./myResourcesList.vue?vue&type=script&lang=js"
export * from "./myResourcesList.vue?vue&type=script&lang=js"
import style0 from "./myResourcesList.vue?vue&type=style&index=0&id=45286bec&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45286bec",
  null
  
)

export default component.exports